/* TypeScript file generated from Tooltip.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as TooltipJS from './Tooltip.res.js';

import type {Overlay_Position_placement as ReactAria_Overlay_Position_placement} from '../../../src/externals/ReactAria.gen';

import type {cursor as StyleX_cursor} from '../../../src/externals/StyleX.gen';

import type {t as FontSizes_t} from '../../../src/resources/theme/FontSizes.gen';

import type {t as Spaces_t} from '../../../src/resources/theme/Spaces.gen';

export type alignment = "auto" | "stretch" | "start" | "center" | "end";

export type Span_tone = "neutral" | "faded" | "success";

export type Span_props<text,tone,italic,bold,size> = {
  readonly text: text; 
  readonly tone?: tone; 
  readonly italic?: italic; 
  readonly bold?: bold; 
  readonly size?: size
};

export type Gap_props<space> = { readonly space?: space };

export type props<children,arrowed,placement,offset,crossOffset,content,disabled,grow,delay,closeDelay,triggerCursor,triggerAlign,altTriggerRef,opened,onOpenChange> = {
  readonly children?: children; 
  readonly arrowed?: arrowed; 
  readonly placement?: placement; 
  readonly offset?: offset; 
  readonly crossOffset?: crossOffset; 
  readonly content: content; 
  readonly disabled?: disabled; 
  readonly grow?: grow; 
  readonly delay?: delay; 
  readonly closeDelay?: closeDelay; 
  readonly triggerCursor?: triggerCursor; 
  readonly triggerAlign?: triggerAlign; 
  readonly altTriggerRef?: altTriggerRef; 
  readonly opened?: opened; 
  readonly onOpenChange?: onOpenChange
};

export const Span_make: React.ComponentType<{
  readonly text: string; 
  readonly tone?: Span_tone; 
  readonly italic?: boolean; 
  readonly bold?: boolean; 
  readonly size?: FontSizes_t
}> = TooltipJS.Span.make as any;

export const Gap_make: React.ComponentType<{ readonly space?: Spaces_t }> = TooltipJS.Gap.make as any;

export const make: React.ComponentType<{
  readonly children?: React.ReactNode; 
  readonly arrowed?: boolean; 
  readonly placement?: ReactAria_Overlay_Position_placement; 
  readonly offset?: number; 
  readonly crossOffset?: number; 
  readonly content: JSX.Element; 
  readonly disabled?: boolean; 
  readonly grow?: boolean; 
  readonly delay?: number; 
  readonly closeDelay?: number; 
  readonly triggerCursor?: StyleX_cursor; 
  readonly triggerAlign?: alignment; 
  readonly altTriggerRef?: any; 
  readonly opened?: boolean; 
  readonly onOpenChange?: (_1:boolean) => void
}> = TooltipJS.make as any;

export const Span: { make: React.ComponentType<{
  readonly text: string; 
  readonly tone?: Span_tone; 
  readonly italic?: boolean; 
  readonly bold?: boolean; 
  readonly size?: FontSizes_t
}> } = TooltipJS.Span as any;

export const Gap: { make: React.ComponentType<{ readonly space?: Spaces_t }> } = TooltipJS.Gap as any;
